import { z } from 'zod';
export const EmployeeSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(32),
    nameTh: z.string().min(1),
    position: z.string().min(1),
    email: z.email().nullable().optional(),
    departmentId: z.uuid().nullable().optional(),
    // ISO date string ('YYYY-MM-DD') on the wire; service converts to Date for Prisma.
    // z.coerce.date() crashes nestjs-zod's z.toJSONSchema() Swagger introspection.
    joined: z.iso.date(),
    bank: z.string().nullable().optional(),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateEmployeeSchema = EmployeeSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
export const UpdateEmployeeSchema = CreateEmployeeSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=employee.js.map